import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/chargeDataEnquiry/chargeDataSearch.scss';
import 'presentation/style/index.scss';
import { DocumentEnquiryDetailContainer } from 'presentation/view/container/DocumentEnquiry/DocumentEnquiryDetailContainer';

CommonEntrypoint(<DocumentEnquiryDetailContainer />)